
import {SoftDeletable} from "../common/SoftDeletable";
import {Nameable} from "../common/Nameable";
import {Identifier} from "../common/Identifier";
import {Module} from "../common/Module";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {Nullable} from "../common/Nullable";
import {isPrivileged} from "../../config/Privileges";
import {ContractorContact} from "./ContractorContact";
import {ContractorOffice} from "./ContractorOffice";
import {IdAndValue} from "../common/IdAndValue";

export const CONTRACTOR_AREA_NAME = "contractors"

/**
 * Module for contractor
 */
export const ContractorModule: Module = {
    identifier: "contractors",
    isPrivileged: ( authUser, privilege) => isPrivileged(
        authUser,
        CONTRACTOR_AREA_NAME,
        ContractorModule.identifier,
        privilege
    )
};

/**
 * adds a property of type Identifier which represents the contractor identifier
 */
export interface ContractorId {
    contractorId: Identifier<number>
}

/**
 * Contractor
 */
export interface Contractor extends ContractorId, SoftDeletable, Nameable {

}

export interface ContractorRequest extends Nameable {
    id: number
    contractedWorks: Nullable< IdAndValue<number, string>[] >
    contacts: Nullable< ContractorContact[] >
    offices: Nullable< ContractorOffice[] >
}

export type ContractorProp = { contractor: Contractor }
export type ContractorRequestProp = { contractorRequest: ContractorRequest }

/**
 * Contractor SELECT API PATH to fetch select options for contractors from
 *
 * response can be filtered by external work to only show contractors that offer the specific type of work
 */
export function contractorSelectRoute( externalWorkId: number | undefined ) {

    if( externalWorkId ) {
        return `contractors/select/${ externalWorkId }`;
    } else {
        return `contractors/select/0`;
    }

}